module.exports = __webpack_public_path__ + "static/media/Montserrat-BlackItalic.f9d1621e.ttf";